//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions, mapMutations } from "vuex";
import FabRightMenuItem from "./FabRightMenuItem.vue";
import FabRightMenuSwitch from "./FabRightMenuSwitch.vue";

export default {
    name: "FabRightMenu",
    components: { FabRightMenuSwitch, FabRightMenuItem },
    props: {
        mini: { type: Boolean, default: true },
        state: { type: String, validator: v => ["tracer", "flow"].includes(v), default: "flow" },
        processInstanceId: { type: String, default: "" },
        readOnly: { type: Boolean, default: false },
        showErrors: { type: Boolean, default: false }
    },
    data() {
        return {
            modalInformation: false,
            show: true,
            switchOptions: [{ label: this.$t("fabricInterface.taskWindow"), value: "flow" }, { label: this.$t("fabricInterface.appTracer"), value: "tracer" }]
        };
    },
    computed: {
        ...mapGetters("diagrams", ["getHasNewComments"]),
        isFlow() { return this.state === "flow"; },
        isPerspectiveInstance() {
            const execData = JSON.parse(localStorage.getItem("executionData"));
            return !!execData.perspectiveId && execData.instanceTab && !execData.taskId;
        }
    },
    methods: {
        ...mapActions("diagrams", ["redDotProcessInstanceId"]),
        ...mapMutations("diagrams", ["setHasNewComments"]),
        onSwitchUpdate(val) {
            this.$emit("action", val);
        },
        onClickToggle() {
            this.$emit("action", "toggle");
        },
        onClickTimeline() {
            this.$emit("action", "timeline");
        },
        //   FOR TASK INFO - DO NOT REMOVE
        onClickInformation() {
            this.modalInformation = true;
            this.$emit("action", "information");
        },
        onClickDocuments() {
            this.$emit("action", "documents");
        },
        onClickErrors() {
            this.$emit("action", "errors");
        },
        onClickComments() {
            this.$emit("action", "comments");
            if (this.getHasNewComments && !this.readOnly) {
                this.redDotProcessInstanceId(this.processInstanceId);
                this.$store.commit("diagrams/setHasNewComments", false);
            }
        }
    }
};
